import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';
import { isMobileOnly } from 'react-device-detect';

export const useStyles = (hasTabs: boolean) => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'grid',
      gap: 2,
      width: isMobileOnly ? 404 : 360,
      maxWidth: '100%',
      padding: '20px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 86px)',
        maxHeight: 'calc(100dvh - 86px)',
        maxWidth: 'unset',
        padding: '12px 16px',
        gap: 1.5,
      },
    },
    tabContent: {
      height: 269,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: isMobileOnly
          ? hasTabs
            ? 'calc(100vh - 184px)'
            : 'calc(100vh - 150px)'
          : '42vh',
        maxHeight: isMobileOnly
          ? hasTabs
            ? 'calc(100vh - 184px)'
            : 'calc(100vh - 150px)'
          : '42dvh',
      },
    },
    content: {
      height: '100%',
      flexGrow: 1,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: 'auto',
      },
    },
  };
};
